// @flow

import ReduceStore from 'PMT/flux/ReduceStore';
import _ from 'lodash';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';

import {
  OrderSettings
} from 'PMT/entities/order';

class OrderSettingsStore extends ReduceStore {

  getInitialState() {
    return {
      orderSettings: null, // OrderSettings
      apiError: null,  // ApiError
    }
  }

  isEmitingCustomEvents(): boolean {
    return true;
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      orderSettings: new OrderSettings(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getOrderSettings(): OrderSettings {
    return this._state.orderSettings;
  }

  reduce(state, action, nextState) {
    switch (action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      case ActionTypes.GET_RESTAURANT_SUCCESS:
      case ActionTypes.PUT_RESTAURANT_SUCCESS:
      
      // Disabled update with PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS. The data does not contain the
      // real orderSettings data of the store, but an empty orderSettings object.
      // This make the order settings on our store invalid (reseted data) and lead to bugs, such as
      // "Sometime the "Synchronize POS" button doesn't appear on the RestaurantMenu page and user 
      // has to refresh the page to see it and click it. This might be related to some information 
      // loaded after the display (in some case)."
      // https://www.notion.so/paymytable/Bugfix-PMT-BO-v1-c9fc99cdb0eb446f9e4ff90dd54a8abd?pvs=4
      // case ActionTypes.PUT_RESTAURANT_MULTIPART_RESPONSE_SUCCESS:
      case ActionTypes.PRO_ACCOUNT_GET_ME_SUCCESS:
        if (!_.isUndefined(action.restaurant) && !_.isUndefined(action.restaurant.orderSettings)
        && !_.isNull(action.restaurant.orderSettings)) {
          nextState.orderSettings = action.restaurant.orderSettings;
        } else {
          // TODO: fix
          console.warn(`could not find order settings in `, action);
        }
        return nextState;

      case ActionTypes.GET_ORDER_SETTINGS_SUCCESS:
        nextState.orderSettings = action.orderSettings;
        this.emitEvent(Events.ON_LOAD_ORDER_SETTINGS_SUCCESS);
        return nextState;

      case ActionTypes.PUT_ORDER_SETTINGS_SUCCESS:
        nextState.orderSettings = action.orderSettings;
        nextState.apiError = null;

        this.emitEvent(Events.ON_UPDATE_ORDER_SETTINGS_SUCCESS);
        return nextState;

      case ActionTypes.PUT_ORDER_SETTINGS_FAILURE:
        nextState.apiError = action.apiError;
        this.emitEvent(Events.ON_UPDATE_ORDER_SETTINGS_FAILURE);
        return nextState;

      default:
        return nextState;
    }
  }

}

export default new OrderSettingsStore();
